import { PROGRESS_CONSTANT } from 'constant/progress-const';
import { getHired } from 'helpers/progress-utils';
import { tab } from 'pages/profile/edit/form/candidateProfile/config';
import React from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const stepConfig = {
  [PROGRESS_CONSTANT.BASIC_INFO]: {
    title: 'What should you do next?',
    body: 'Click to access your profile page, review your details, and update your role to proceed further and unlock more features.',
    buttons: [
      {
        name: 'proceed',
        route: `/home/profile/edit?value=${tab.role}`,
        variant: 'primary'
      }
    ]
  },
  [PROGRESS_CONSTANT.ASSESSMENT]: {
    title: 'What should you do next?',
    body: 'Complete a core quiz relevant to your role to assess your skills and enhance your knowledge.',
    buttons: [
      { name: 'Take quiz', route: '/home/ladder/basic', variant: 'primary' }
    ]
  },
  [PROGRESS_CONSTANT.LOGIC]: {
    title: 'Sharpen Your Mind',
    body: 'Challenge yourself with logic questions and problem-solving exercises to enhance critical thinking and decision-making skills.',
    buttons: []
  }
};

const ActionCard = ({ currentStep }: { currentStep: string }) => {
  const navigate = useNavigate();
  const jobOpportunitiesObtained = getHired.includes(currentStep);

  const current = stepConfig[currentStep];

  return (
    <Row className="g-4">
      <Col xs={12} sm={6} md={4}>
        <Card className="h-100">
          <Card.Body className="d-flex flex-column">
            <Card.Title className="fw-semibold fs-7">
              We’ve found jobs for
            </Card.Title>
            <Card.Text className="fs-4 fw-bolder">800+</Card.Text>
            <Card.Text>
              Developers from India so far and you could be the next one!
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Card className="h-100">
          <Card.Body className="d-flex flex-column">
            <Card.Title className="fw-semibold fs-7">
              {current?.title}
            </Card.Title>
            <Card.Text className="fs-8">{current?.body}</Card.Text>
            <div className="d-flex gap-4 mt-auto">
              {current?.buttons?.map((btn, idx: number) => (
                <Button
                  variant={btn?.variant}
                  key={idx}
                  onClick={() => navigate(btn?.route)}
                >
                  {btn?.name}
                </Button>
              ))}
            </div>
          </Card.Body>
        </Card>
      </Col>
      {jobOpportunitiesObtained && (
        <Col xs={12} sm={6} md={4}>
          <Card className="h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title className="fw-semibold fs-7">
                Job Opportunities
              </Card.Title>
              <Card.Text>
                You can find all the available job opportunities at the Jobs tab
              </Card.Text>
              <div className="mt-auto">
                <Button variant="primary">Explore the job tab</Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default ActionCard;
